const ShortStepFragment = `
    id
    order
    status
    renderAttributes
`

export default ShortStepFragment
